import { OreDivider, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { createApiBankAccountRepository } from '@/Contract/infrastructure'
import { AccountProvider } from '@/Contract/ui/context'
import { AccountingStatusBanner } from '@/Contract/ui/molecules'
import { createApiInvoiceRepository } from '@/Invoices/infrastructure'
import { InvoiceProvider } from '@/Invoices/ui/context'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { PageWrapper } from '@/Shared/ui/layout'
import { navigationRoutes } from '@/Shared/ui/routers'
import { createApiTpvRepository } from '@/Store/infrastructure'
import { TpvProvider } from '@/Store/ui/context'
import { TpvsGuide, TpvsList } from '@/Store/ui/organisms'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useWebTagPermissions } from '@/User/context'
import { useUserData } from '@/User/ui/context'

export const TpvsPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()
  const { hasPermission } = useWebTagPermissions()

  return (
    <AccountProvider
      merchantId={merchant.id}
      repository={createApiBankAccountRepository()}
      origin={navigationRoutes.home}
    >
      <InvoiceProvider repository={createApiInvoiceRepository()}>
        <TpvProvider repository={createApiTpvRepository()} id={merchant.id}>
          <PageWrapper
            paddingSmaller
            paddingTop={8}
            style={{
              paddingRight: 40,
              paddingLeft: 40,
              minWidth: '-webkit-fill-available',
              marginRight: 0,
              marginLeft: 0,
            }}
          >
            <OreHeading as="h1" size="title-sm">
              {t(storesTranslation.tpvs.pageTitle)}
            </OreHeading>
            <OreDivider space="larger-bottom" />
            <OreStack direction="column" space="2xlarge" placeContent="stretch">
              {hasPermission(WebTagPermissionEnum.ACTION_BANK_ACCOUNT_CHANGE) && (
                <AccountingStatusBanner origin={navigationRoutes.storeTPV} />
              )}
              <OreText style={{ whiteSpace: 'pre-line' }}>
                {t(storesTranslation.tpvs.introduction)}
              </OreText>
              <OreStack direction="row" space="2xlarge" placeItems="start" sameSize>
                <TpvsList />
                <TpvsGuide />
              </OreStack>
            </OreStack>
          </PageWrapper>
        </TpvProvider>
      </InvoiceProvider>
    </AccountProvider>
  )
}
